import * as dateLocales from 'date-fns/locale';

export const getDateLocale = (code: string) =>
  dateLocales[code.replace(/-/g, '')] || dateLocales.enGB;
